import $ from 'jquery';
/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap($el) {

  // Find marker elements within map.
  var $markers = $el.find('.map__marker');
  // Create gerenic map.
  var mapArgs = {
    zoom: 18,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    styles: [
      {
        featureType: "administrative.country",
        elementType: "geometry.stroke",
        stylers: [{ color: "#242E4E" }, { weight: 2 }],
      },
      {
        featureType: "administrative.country",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{ color: "#34778E" }],
      },
      {
        featureType: "administrative.locality",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#ADC6CF" }, { weight: 1 }],
      },
      {
        featureType: "administrative.neighborhood",
        elementType: "labels.text.fill",
        stylers: [{ color: "#34778E" }],
      },
      {
        featureType: "administrative.neighborhood",
        elementType: "labels.text.stroke",
        stylers: [{ visibility: "off" }],
      },
      { featureType: "administrative.province", stylers: [{ visibility: "off" }] },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [{ color: "#ADC6CF" }],
      },
      {
        featureType: "landscape.natural",
        elementType: "geometry",
        stylers: [{ color: "#E6DA90" }],
      },
      {
        featureType: "landscape.natural",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ color: "#ADC6CF" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#E6DA90" }],
      },
      {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#242E4E" }, { weight: 1.5 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ color: "#242E4E" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#242E4E" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway.controlled_access",
        elementType: "geometry.fill",
        stylers: [{ color: "#242E4E" }],
      },
      {
        featureType: "road.highway.controlled_access",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ color: "#34778E" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "off" }],
      },
      { featureType: "transit.line", stylers: [{ visibility: "off" }] },
      {
        featureType: "transit.station",
        elementType: "geometry.fill",
        stylers: [{ color: "#ADC6CF" }],
      },
      {
        featureType: "transit.station",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.station",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#34778e" }],
      },
      {
        featureType: "water",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  };

  var map = new google.maps.Map($el[0], mapArgs);

  // Add markers.
  map.markers = [];
  $markers.each(function () {
    initMarker($(this), map);
  });


  // Center map based on markers.
  centerMap(map);

  // Return map instance.
  return map;
}

// var infowindow = new google.maps.InfoWindow({});

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker($marker, map) {
  var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

  // Get image for mapMarker
  const svgIcon = 'data:image/svg+xml;charset=UTF-8,' +
    encodeURIComponent(`<svg width="79" height="100" viewBox="0 0 79 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_11_444)">
<path d="M39.4072 0C17.6729 0 0 17.6729 0 39.4072C0 61.1416 22.9418 85.8397 39.4072 100C55.8727 85.8397 78.8145 61.1416 78.8145 39.4072C78.8145 17.6729 61.1416 0 39.4072 0Z" fill="white"/>
<g clip-path="url(#clip1_11_444)">
<path d="M36.2542 31.1001V31.5238H37.282C38.0136 31.5238 38.6058 32.197 38.6385 33.0398V45.2617L30.5389 31.7764C30.284 31.352 29.8672 31.0991 29.4224 31.0991H24V31.5228H25.028C25.7805 31.5228 26.3906 32.2334 26.3906 33.1099V50.6366C26.3906 51.5131 25.7805 52.2237 25.028 52.2237H24V52.6474H29.1967V52.2237H28.1689C27.4164 52.2237 26.8063 51.5131 26.8063 50.6366V33.248H26.8583L38.2291 52.1139C38.4286 52.4449 38.7885 52.6474 39.177 52.6474L45.3903 52.6441V52.2204H44.3626C43.61 52.2204 42.9999 51.5098 42.9999 50.6333V41.9745C43.0252 41.5973 43.3339 41.2982 43.7149 41.2982H44.9788C45.9204 41.2982 46.6516 41.4798 47.1729 41.843C47.6937 42.2062 48.0844 42.6904 48.3451 43.2956C48.6053 43.9009 48.7705 44.5924 48.8411 45.3688C48.9111 46.1457 48.7844 49.8765 48.8248 50.7037C48.8445 51.2484 48.8895 51.8286 48.9601 52.4438C49.0301 53.0596 49.2154 53.6294 49.516 54.1538C49.8167 54.6787 50.2773 55.1176 50.8987 55.4704C51.5195 55.8231 52.3812 56 53.4835 56C54.0244 56 54.4754 55.9646 54.836 55.8941C55.1967 55.8231 55.5018 55.7277 55.7528 55.6066C56.0031 55.4854 56.2232 55.3394 56.414 55.1677C56.6042 54.9965 56.7996 54.8096 57 54.6078L56.6995 54.3354C56.4989 54.5374 56.2682 54.7544 56.0081 54.9862C55.7475 55.2184 55.4168 55.3341 55.0164 55.3341C54.6557 55.3341 54.3799 55.2637 54.1897 55.1222C53.9991 54.9813 53.8487 54.6985 53.739 54.2748C53.6286 53.8511 53.5436 53.2564 53.4835 52.4894C53.4234 51.7228 53.5247 47.7749 53.4246 46.5038C53.3443 45.4143 53.1391 44.5469 52.8084 43.9009C52.4779 43.2556 52.0315 42.751 51.4709 42.3878C50.9098 42.0246 50.2433 41.7523 49.4722 41.5707C48.7006 41.3891 47.8238 41.2074 46.8424 41.0258V40.8745C47.5233 40.8141 48.2144 40.6884 48.9161 40.4962C49.6173 40.3047 50.2536 40.0272 50.8248 39.664C51.3956 39.3008 51.8617 38.8316 52.2224 38.2567C52.583 37.6816 52.7633 36.9907 52.7633 36.1836C52.7633 35.1749 52.5275 34.3374 52.0571 33.6717C51.5861 33.0058 50.99 32.4763 50.2687 32.0827C49.5473 31.6892 48.7508 31.4122 47.8791 31.2506C47.0076 31.0891 46.278 31.0411 45.3995 31.0084C44.5585 30.9771 43.7268 31.0423 42.9051 31.0538C40.1938 31.0918 39.5158 31.0988 38.7057 31.0991L36.2542 31.1001ZM44.2274 40.8745H43.7149C43.3339 40.8745 43.0252 40.5755 42.9999 40.1984V33.2446L42.9951 33.243V32.1847C42.9951 31.8098 43.279 31.4972 43.6497 31.463C43.6519 31.4627 43.6541 31.4625 43.6563 31.4622C43.8766 31.4424 44.0968 31.4322 44.3176 31.4322C45.0789 31.4322 45.7049 31.5333 46.196 31.7347C46.6868 31.9366 47.0723 32.2445 47.3532 32.6579C47.6336 33.0716 47.8341 33.5959 47.9543 34.2315C48.0745 34.8669 48.1346 35.629 48.1346 36.5164C48.1346 37.0611 48.0995 37.596 48.0295 38.1205C47.9591 38.6454 47.7937 39.1145 47.5335 39.5277C47.273 39.9415 46.8822 40.2693 46.3615 40.5114C45.8402 40.7536 45.1291 40.8745 44.2274 40.8745Z" fill="#223B8B"/>
</g>
</g>
<defs>
<clipPath id="clip0_11_444">
<rect width="78.8145" height="100" fill="white"/>
</clipPath>
<clipPath id="clip1_11_444">
<rect width="33" height="25" fill="white" transform="translate(24 31)"/>
</clipPath>
</defs>
</svg>`);

  // Create marker instance.
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: svgIcon,
  });

  if (themeVars?.googleMapLink) {
    marker.addListener("click", () => {
      window.open(themeVars.googleMapLink, "_blank");
    });
  }

  // Append to reference for later use.
  map.markers.push(marker);
}


/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap(map) {

  // Create map boundaries from all map markers.
  var bounds = new google.maps.LatLngBounds();
  map.markers.forEach(function (marker) {
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng(),
    });
  });

  // Case: Single marker.
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());

    // Case: Multiple markers.
  } else {
    // map.fitBounds( bounds );
    map.setCenter(bounds.getCenter());
  }
}

// Render maps on page load.
$(window).on('load', function () {
  setTimeout(function() {
    $('.js-map').each(function () {
      var map = initMap($(this));
      return map
    });
  }, 500);
} );
